import * as React from "react";
import "./formGroup.scss";

export const FormGroup = ({ children }: any) => {
  return <div className="form-group">{children}</div>;
};
